import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { api } from '../../../../../../services';
import { NewgroupIcon } from '../../../../../../common/icons';
import AirModal from '../../../../../../common/components/AirModal';
import AirButton from '../../../../../../common/components/AirButton';
import { Transfer } from 'antd';
import './ManageVehiclesModal.css';

@inject('translationsStore', 'groupsStore', 'commonStore')
@observer
export default class ManageVehiclesModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      availableVehicles: [],
      selectedVehicles: [],
      targetVehicles: [],
    };
  }

  componentDidMount() {
    this.loadGeofenceVehicles();
  }

  loadGeofenceVehicles = () => {
    this.setState({ loading: true });
    api('getGeofenceAvailableVehicles')
    .then(vehicles => {
      const availableVehicles = [];

      for (let vehicle of vehicles) {
        availableVehicles.push(
          {
            key: vehicle.id.toString(),
            title: `${vehicle.plate}`,
            description: `${vehicle.make.descrizione} ${vehicle.model.descrizione}`
            //${vehicle.type.descrizione}
          }
        )
      }
      this.setState({ availableVehicles, loading: false });
    })
    .catch(error => ({ error }))
    .finally(() => {
      this.setState({ loading: false });
    });
  };

  handleTransferChange = (nextTargetKeys, direction, moveKeys)  => {
    this.setState({ targetVehicles: nextTargetKeys });
  };

  handleTransferSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    this.setState({ selectedVehicles: [...sourceSelectedKeys, ...targetSelectedKeys] });
  };

  show = (targetVehicles) => {
    this.setState({ targetVehicles: targetVehicles.map(x => x.carId? x.carId : x).map(String), visible: true });
  };

  close = () => {
    this.setState({ visible: false });
  };

  updateGeofenceVehicles = () => {
    this.props.onUpdate(this.state.targetVehicles);
    this.setState({ visible: false });
  }

  render() {
    const { translationsStore } = this.props;
    const { selectedVehicles, targetVehicles, availableVehicles } = this.state;
    return (
      <div className="ManageVehiclesModal">
        <AirModal
          className="ManageVehiclesModal"
          visible={this.state.visible}
          icon={<NewgroupIcon style={{ width: '62px', height: '45px' }} />}
          cancelButton={<AirButton size="large" label={translationsStore.translate('geofence.detail.manageVehicles.cancel')} />}
          onCancel={this.close}
          okButton={<AirButton size="large" light="true" label={translationsStore.translate('geofence.detail.manageVehicles.update')} />}
          onOk={this.updateGeofenceVehicles}
          title={translationsStore.translate('geofence.detail.manageVehicles.title')}
          subtitle={translationsStore.translate('geofence.detail.manageVehicles.subtitle')}
          width="676px"
        >
          <div>
            <div className="header">
              <div className="left">{translationsStore.translate('geofence.detail.manageVehicles.availableVehicles')}</div>
              <div className="right">{translationsStore.translate('geofence.detail.manageVehicles.assignedVehicles')}</div>
            </div>
            <div>
              <Transfer
                dataSource={availableVehicles}
                showSearch
                listStyle={{
                  width: 248,
                  height: 268
                }}
                operations={['>', '<']}
                locale={{ itemUnit: translationsStore.translate('geofence.detail.manageVehicles.itemUnit'), itemsUnit: translationsStore.translate('geofence.detail.manageVehicles.itemsUnit'), notFoundContent: translationsStore.translate('geofence.detail.manageVehicles.notFoundContent'), searchPlaceholder: translationsStore.translate('geofence.detail.manageVehicles.searchPlaceholder') }}
                targetKeys={targetVehicles}
                selectedKeys={selectedVehicles}
                onChange={this.handleTransferChange}
                onSelectChange={this.handleTransferSelectChange}
                render={item => `${item.title}`}
              />
            </div>
          </div>
        </AirModal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Geofence/GeofenceDetail/GeofenceForm/ManageVehiclesModal/ManageVehiclesModal.js